// app/api/actions/category-actions.ts
'use server'; // Wichtig: Markiert dies als Server Actions Modul

import { getProducts } from '@/app/lib/productUtil';
import { ProductsResponse, UnifiedProductDisplay } from '@/app/api/types';

interface LoadMoreResult {
  items: UnifiedProductDisplay[];
  hasMore: boolean;
}

export async function loadMoreCategoryProducts(
  categoryId: string,
  page: number, // Die nächste zu ladende Seite
  limit: number,
  urgentOnly: boolean
): Promise<LoadMoreResult> {
  try {
    // Rufe die bestehende getProducts Funktion auf
    const productsResponse: ProductsResponse = await getProducts(
      categoryId,
      page,
      limit,
      urgentOnly
    );

    // Gib nur die benötigten Daten zurück
    return {
      items: productsResponse.items,
      hasMore: productsResponse.hasMore,
    };
  } catch (error) {
    console.error('Error loading more category products:', error);
    // Im Fehlerfall leere Liste und hasMore=false zurückgeben
    return {
      items: [],
      hasMore: false,
    };
  }
}